import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as Assets from 'fixedassets/components';

import {
  getAsset as fetch,
  getHistorics as fetchHistorics,
  resetAssetsForm as reset,
  requestOutputAsset,
  requestInputAsset,
  requestAceptOutput,
  requestRejectOutput,
} from 'containers/assets/actions';
import { getCompany, getSubcompany, getPermissions, getUser } from 'auth/selectors';
import { getIsFetching, getAsset, getHistorics } from 'selectors/assets';

import AssetsFormConfig from 'containers/assets/AssetsFormConfig';

import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups
import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups
import { addGrowlError, addGrowlSuccess } from 'messages/actions';
import { valueFromEvent, createRoute } from 'lib/util';

class AssetsDetailContainer extends Component {
  componentWillMount = () => {
    const {
      company,
      subcompany,
      match: {
        params: { aid },
      },
    } = this.props;
    this.props.fetch(aid, company.id, subcompany.id);
    //historics
    this.props.fetchHistorics(aid, company.id, subcompany.id);
    //Groups
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'activos', columnSearch: ['module'] }; // Filtros para traer solo los grupos de empleados
    this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  };

  componentWillUnmount = () => this.props.reset();

  OutputAsset = (message) => {
    // this.props.requestOutputAsset(this.props.match.params.aid, this.props.company.id, this.props.subcompany.id, message)
    this.requestApi(this.props.requestOutputAsset, message);
  };

  InputAsset = (message) => {
    // this.props.requestInputAsset(this.props.match.params.aid, this.props.company.id, this.props.subcompany.id, message)
    this.requestApi(this.props.requestInputAsset, message);
  };

  AceptOutput = (message) => {
    // this.props.requestAceptOutput(this.props.match.params.aid, this.props.company.id, this.props.subcompany.id, message)
    this.requestApi(this.props.requestAceptOutput, message);
  };

  RejectOutput = (message) => {
    // this.props.requestRejectOutput(this.props.match.params.aid, this.props.company.id, this.props.subcompany.id, message)
    this.requestApi(this.props.requestRejectOutput, message);
  };

  // A signed custody voucher was saved: reload the asset (its files) and its historic.
  handleCustodyVoucherSaved = () => {
    const { company, subcompany, match } = this.props;
    this.props.fetch(match.params.aid, company.id, subcompany.id);
    this.props.fetchHistorics(match.params.aid, company.id, subcompany.id);
  };

  requestApi = (request, message) => {
    request(this.props.match.params.aid, this.props.company.id, this.props.subcompany.id, message)
      .then(({ value }) => {
        this.props.success(value.message);
        // this.props.history.push(
        //   createRoute(this.props.company.id, this.props.subcompany.id, "employees")
        // );
      })
      .catch((err) => {
        this.props.error(err.message);
      });
  };

  render = () => (
    <AssetsFormConfig
      render={({ locations, sublocations, inpcs }) => (
        <Assets.DetailView
          isFetching={this.props.isFetching}
          asset={this.props.asset}
          historics={this.props.historics}
          error={this.props.error}
          success={this.props.success}
          user={this.props.user}
          onCustodyVoucherSaved={this.handleCustodyVoucherSaved}
          company={this.props.company}
          subcompany={this.props.subcompany}
          permissions={this.props.permissions}
          inpcs={inpcs}
          locations={locations}
          sublocations={sublocations}
          groups={this.props.groups}
          OutputAsset={this.OutputAsset}
          InputAsset={this.InputAsset}
          AceptOutput={this.AceptOutput}
          RejectOutput={this.RejectOutput}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  asset: getAsset(state),
  historics: getHistorics(state),
  company: getCompany(state),
  user: getUser(state),
  permissions: getPermissions(state),
  isFetching: getIsFetching(state),
  subcompany: getSubcompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
});
const mapDispatchToProps = {
  fetch,
  fetchHistorics,
  reset,
  getCustomFields: getCustomFieldsEmployees,
  getGroups: getGroups,
  error: addGrowlError,
  success: addGrowlSuccess,
  requestOutputAsset,
  requestInputAsset,
  requestAceptOutput,
  requestRejectOutput,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetsDetailContainer));



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/containers/AssetDetailContainer.js